import { useMutation, useQueryClient } from '@tanstack/react-query';
import { approveMeasurement, type ApproveMeasurementPo } from '@/integrations/faturamento/client';

/** `po` só vai quando o cliente pagador exige PO (EDD-582). */
export interface ApproveMeasurementInput {
  id: string;
  po?: ApproveMeasurementPo;
}

/**
 * Aprovação da medição pelo gerador. Libera o ciclo para o faturamento, então o estado exibido no
 * extrato e no detalhe muda — as duas consultas são invalidadas.
 */
export function useApproveMeasurement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, po }: ApproveMeasurementInput) => approveMeasurement(id, po),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['invoice-details'] });
      void queryClient.invalidateQueries({ queryKey: ['invoices'] });
      // A aprovação vive em consulta própria — sem isto, quem acabou de aprovar não veria a
      // seção de histórico da medição aparecer.
      void queryClient.invalidateQueries({ queryKey: ['measurement-approval'] });
    },
  });
}
